import { createElement, useState } from '@wordpress/element';
import { GeneralSettingsTab, RegistrationFieldsTab } from './Tabs';

const App = () => {
  const [activeTab, setActiveTab] = useState('general');

  const tabs = [
    {
      id: 'general',
      label: 'General Settings',
      icon: (
        <svg class="cpiw-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.03 1.55V21a2 2 0 1 1-4 0v-.09a1.7 1.7 0 0 0-1.03-1.55 1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.7 1.7 0 0 0 .34-1.87 1.7 1.7 0 0 0-1.55-1.03H3a2 2 0 1 1 0-4h.09a1.7 1.7 0 0 0 1.55-1.03 1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.7 1.7 0 0 0 1.87.34h0A1.7 1.7 0 0 0 10.03 3H10a2 2 0 1 1 4 0h-.03a1.7 1.7 0 0 0 1.03 1.55h0a1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.7 1.7 0 0 0-.34 1.87v0A1.7 1.7 0 0 0 21 10.03V10a2 2 0 1 1 0 4h-.09a1.7 1.7 0 0 0-1.51 1z"></path></svg>
      ),
    },
    {
      id: 'fields',
      label: 'Registration Fields',
      icon: (
        <svg class="cpiw-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"></rect><path d="M7 7h7"></path><path d="M7 11h10"></path><rect x="7" y="14" width="3" height="3" rx="0.5"></rect><path d="M7.8 15.5l0.8 0.8 1.6-1.6"></path></svg>
      ),
    },
  ];

  return (
    <div className="plugin-settings">

      {/* ── Page Header ── */}
      <div className="cf-page-header">
        <div className="cf-page-header__inner">
          <div className="cf-page-header__brand">
            <div>
              <h1 className="cf-page-header__title">Custom Fields Account Registration For WooCommerce</h1>
              <p className="cf-page-header__subtitle">Registration &amp; Account Field Manager</p>
            </div>
          </div>
        </div>
      </div>

      {/* ── Promo Banner ── */}
      <div className="cf-banner">
        <div className="cf-banner__text">
          <div className="cf-banner__label">Plugin999</div>
          <p className="cf-banner__title">Enjoying the plugin? Help us grow — leave a review or reach out for support.</p>
        </div>
        <div className="cf-banner__actions">
          <a
            className="cf-btn cf-btn--primary"
            href="https://www.plugin999.com/plugin/custom-fields-account-registration-for-woocommerce/"
            target="_blank"
            rel="noreferrer"
          >
             <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="#ffc83d"><path d="M3 7l4 4 5-7 5 7 4-4-2 13H5L3 7z"/></svg>
            Pro Version 
          </a>
          <a
            className="cf-btn cf-btn--ghost"
            href="https://www.plugin999.com/support/"
            target="_blank"
            rel="noreferrer"
          >
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:14,height:14,stroke:'currentColor',fill:'none',strokeWidth:2,strokeLinecap:'round',strokeLinejoin:'round'}}>
              <circle cx="12" cy="12" r="10"/>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            Support
          </a>
          <a
            className="cf-btn cf-btn--primary"
            href="https://wordpress.org/support/plugin/custom-fields-account-registration-for-woocommerce/reviews"
            target="_blank"
            rel="noreferrer"
          >
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:15,height:15,stroke:'currentColor',fill:'#ffc83d',strokeWidth:0,strokeLinecap:'round',strokeLinejoin:'round'}}><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
            Rate Plugin
          </a>
        </div>
      </div>

      {/* ── Main Content ── */}
      <div className="cf-content">

        {/* Tabs Nav */}
        <div className="cf-tabs">
          <div className="cf-tabs__nav">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`cf-tab-btn${activeTab === tab.id ? ' cf-tab-btn--active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
                type="button"
              >
                {tab.icon}
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Panels */}
        <div className={`cf-tab-panel${activeTab === 'general' ? ' cf-tab-panel--active' : ''}`}>
          <GeneralSettingsTab />
        </div>

        <div className={`cf-tab-panel${activeTab === 'fields' ? ' cf-tab-panel--active' : ''}`}>
          <RegistrationFieldsTab />
        </div>

      </div>
    </div>
  );
};

export default App;
